import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { CardComponent } from '@components/card/card.component';

@Component({
  selector: 'app-what-happens-next',
  imports: [CardComponent, NgOptimizedImage],
  templateUrl: './what-happens-next.html',
  styleUrl: './what-happens-next.scss',
})
export class WhatHappensNext {}
